import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { UnknownProduct } from '../../../data/receiving';
import { emDashIfEmpty, productHeadColumns } from './product-columns';

const COLUMNS = [
  ...productHeadColumns<UnknownProduct>((p) => p),
  defineColumn<UnknownProduct>({
    id: 'Item code',
    minWidth: 100,
    maxWidth: 160,
    accessorFn: (p) => emDashIfEmpty(p.item_code || p.raw_item_code),
    cell: ({ value }) => <span className="font-mono">{value}</span>,
  }),
  defineColumn<UnknownProduct>({
    id: 'Also used by',
    minWidth: 280,
    maxWidth: 520,
    accessorFn: (p) =>
      p.conflicts.map((c) => [c.brand, c.description, c.size].filter(Boolean).join(' ')).join('; '),
  }),
];

export function DuplicateItemCodesTable({ rows }: { rows: UnknownProduct[] }) {
  return <TanStackTable data={rows} columns={COLUMNS} />;
}
